import axios from '@fs/zion-axios'
import { i18n } from '@fs/zion-locale'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const hardCodedCategoriesData = {
  categories: [
    { categoryId: 'FAKE1', category: 'Places, Records and Research' },
    { categoryId: 'FAKE2', category: 'FamilySearch.org Questions' },
    { categoryId: 'FAKE3', category: 'Calling or Temple Questions' },
    { categoryId: 'FAKE4', category: 'General Questions' },
    { categoryId: 'FAKE5', category: 'Help Me Find an Expert' },
    { categoryId: 'FAKE6', category: 'Help with your computer or device' },
    { categoryId: 'FAKE7', category: 'Exhibitors' },
  ],
}

/**
 * NOTE: This is hardcoded since there is no flag in the data to separate "top level" ones from others.
 */
export const getTopLevelSupportCategories = () => {
  return Promise.resolve({
    data: hardCodedCategoriesData,
  })
}

export const getSupportCategories = () => {
  return axios.get(`${serviceBaseUrl}/support/categories`)
}

export const searchForSupportCategories = ({ query }) => {
  return axios.get(`${serviceBaseUrl}/support/categories/search?category=${encodeURIComponent(query)}&limit=10`)
}

/**
 * Looks up the experts in the given category. When no available, it will fetch experts in the backup category.
 * @param {category} category This desired category of experts
 * @param {category} backupCategory The default backup category, such as "general"
 */
export const searchForExpertsInCategory = async ({ category, backupCategory }) => {
  const response = await axios.get(
    `${serviceBaseUrl}/support/experts/search?category=${category}&language=${i18n.language}`
  )

  if (Object.keys(response?.data?.results || {})?.length === 0 && backupCategory) {
    return axios.get(`${serviceBaseUrl}/support/experts/search?category=${backupCategory}&language=${i18n.language}`)
  }

  return Promise.resolve(response)
}

/**
 * Looks up the experts that speak this language.
 */
export const searchForLanguageExperts = ({ language }) => {
  return axios.get(`${serviceBaseUrl}/support/experts/search/languages?language=${language || i18n.language}`)
}
